import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useResetSignUpError } from 'src/hooks/useResetSignupErrors';
import { setError } from 'src/store/user/actions';
import { RootState } from 'src/types/store-types';
import * as Yup from 'yup';
import Dropdown from '../Dropdown';
import { Typography } from '../Typography';
import _styles from './styles.module.scss';

type IProps = {
  name: string;
  value: string;
  regexp: string;
  label: boolean;
  onChange: (e: any) => void;
  placeholder?: string;
  required?: boolean;
};

const BankAccountType_Select: FC<IProps> = ({ onChange, name, value, required, label }) => {
  const { t }: Translation = useTranslation();

  const _setErrorReq = useConnectedAction(setError);

  const resetSignUpError = useResetSignUpError();

  const { errors: signUpErrors, accountType } = useSelector((state: RootState) => state.user);

  const [bankAccountTypeVal, setBankAccountType] = useState<SelectOptionType | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [banksAccountType, setBanksAccountType] = useState<SelectOptionType[]>([]);

  const validationSchema = Yup.object().shape({
    bankAccountType: Yup.string().required(t('requiredField')),
  });

  const handleValidate = async (value: string | number): Promise<void> => {
    try {
      await validationSchema.validate({ bankAccountType: value }, { abortEarly: false });
      resetSignUpError('bankAccountType');
    } catch (error: any) {
      if (error.name === 'ValidationError') {
        _setErrorReq({ ...signUpErrors, bankAccountType: error.errors[0] });
      }
    }
  };

  const handleSelect = (option: SelectOptionType): void => {
    onChange({ target: { name, value: option.value } });
    setBankAccountType(option);
    handleValidate(option.value);
  };

  useEffect(() => {
    !value && isDropdownOpen && handleValidate(value);
  }, [isDropdownOpen]);

  useEffect(() => {
    if (accountType && accountType?.length) {
      const options: SelectOptionType[] = accountType.map((bankName: string) => ({
        label: t(bankName).toLowerCase().replace(/\s+/g, '_'),
        value: bankName,
      }));
      handleSelect(options[0]);
      setBanksAccountType(options);
    }
  }, [accountType]);

  return (
    <div className={_styles.bankAccountType_select__wrapper}>
      {label && (
        <Typography className={_styles.label} variant={'body5'}>
          {t(label)} {required && <span>*</span>}
        </Typography>
      )}
      <Dropdown
        list={banksAccountType}
        selected={bankAccountTypeVal}
        setIsDropdownOpen={setIsDropdownOpen}
        handleSelect={handleSelect}
        className={_styles.bankAccountType_select}
        listClassName={_styles.bankAccountType_select__list}
      />
      <span className={_styles.error}>{signUpErrors.bankAccountType}</span>
    </div>
  );
};
export default BankAccountType_Select;
